/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    covMiscellaneous: {
        id: 'quoteandbind.PPLEnvLinedirectives.templates.Miscellaneous.Coverages',
        defaultMessage: 'Coverages'
    },
    formMiscellaneous:{
        id: 'quoteandbind.PPLEnvLinedirectives.templates.Miscellaneous.Endorsements',
        defaultMessage: 'Endorsements'
    }
});